import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodBurger: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 0a7 7 0 0 1 7 7H1a7 7 0 0 1 7-7m8 8.5v2H0v-2zM11 16a4 4 0 0 0 4-4H1a4 4 0 0 0 4 4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodBurger
